import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss';
import { ReactComponent as Strength_based_fat_lossIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_based_fat_loss.svg';
import { ReactComponent as Low_impact_conditioningIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_conditioning.svg';
import { ReactComponent as Cardio_strength_mixIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardio_strength_mix.svg';
import { ReactComponent as Hiit_circuitsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/hiit_circuits.svg';

interface WeightLossStep4Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  strength_based_fat_loss: <Strength_based_fat_lossIcon />,
  hiit_circuits: <Hiit_circuitsIcon />,
  low_impact_conditioning: <Low_impact_conditioningIcon />,
  cardio_strength_mix: <Cardio_strength_mixIcon />,
};

// How should this goal be approached?
export const WeightLossStep4: FC<WeightLossStep4Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'weight_loss',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
